import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d69f53e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_3 = {
  key: 1,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_4 = {
  key: 1,
  class: "fs-7 fw-bold"
}
const _hoisted_5 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_6 = {
  key: 1,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "fas fa-eye-slash cursor-pointer me-2"
}
const _hoisted_9 = { class: "submenu" }
const _hoisted_10 = { class: "d-block mb-2 fs-8" }

import { ReplayName } from '@/constants/common'
import Avatar from '@/components/avatar/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Submenu from '@/components/submenu/subMenuAdmin.vue'
import TargetTag from '@/components/target-tag/index.vue'
import { ComputedRef, PropType } from 'vue'
import { CommentType } from '@/store/modules-community-admin/community-site'
import { computed } from 'vue-demi'
import { translate } from '@/languages/i18n'
import { ACCOUNT_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import { ChangeTime } from '@/constants/datepicker'


export default /*#__PURE__*/_defineComponent({
  props: {
  comment: Object as PropType<CommentType>,
  id_comment: {
    type: String,
    default: null,
  },
},
  emits: ['showDeleteCommentModal', 'updateCommentPublishedState', 'showCommentUserDetailInformation'],
  setup(__props, { emit }) {

const props = __props




const store = useStore()
const listUser = computed<ComputedRef>(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])

const published = computed(() => props.comment?.published ?? false)

const menu = computed(() => {
  if (published.value) {
    return [
      { icon: '<i class="fas fa-eye-slash" />', title: translate('privateComment'), onclick: updateCommentPublishedState },
      { icon: '<i class="far fa-trash-alt" />', title: translate('deleteComment'), action: 'delete' },
    ]
  } else {
    return [
      { icon: `<img src="${require('@/assets/images/eye.svg')}" width="19" height="19" />`, title: translate('publicAdmin'), onclick: updateCommentPublishedState },
      { icon: '<i class="far fa-trash-alt" />', title: translate('deleteComment'), action: 'delete' },
    ]
  }
})

const showDeleteCommentModal = () => {
  emit('showDeleteCommentModal', props.comment)
}

const updateCommentPublishedState = () => {
  emit('updateCommentPublishedState', props.comment)
}

const handleShowUser = () => {
  if (props.comment.userType === 'community_admin' || props.comment.is_deleted_in_30_days === 2) {
    return
  }
  emit('showCommentUserDetailInformation', props.comment)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(!__props.comment?.published ? 'opacity-30' : '')
    }, [
      _createVNode(Avatar, {
        is_deleted_in_30_days: __props.comment.is_deleted_in_30_days,
        user_image_url: __props.comment?.image_url,
        size: 'small',
        userType: __props.comment.user_type
      }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["w-100", { 'message-highlight': __props.comment?.id === __props.id_comment }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex", !__props.comment?.published ? 'opacity-30' : ''])
        }, [
          _createVNode(UserAliasIcon, {
            userType: __props.comment.user_type,
            class: "mb-2 fw-bold"
          }, null, 8, ["userType"]),
          (__props.comment.is_deleted_in_30_days !== 2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = () => handleShowUser())
              }, [
                (__props.comment?.user_type !== 'community_admin')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.comment?.management_no + ' ' + _unref(ReplayName)(__props.comment?.is_deleted_in_30_days, __props.comment?.available, __props.comment?.family_name, __props.comment?.given_name, __props.comment?.user_type)) + " " + _toDisplayString(__props.comment?.user_type == 'alumni' && [0, 1].includes(__props.comment?.is_deleted_in_30_days) ? `（ ${__props.comment?.display_name} ）` : ''), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.comment?.management_no + ' ' + __props.comment?.display_name), 1))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                (__props.comment?.user_type !== 'community_admin')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.comment?.management_no + ' ' + _unref(ReplayName)(__props.comment?.is_deleted_in_30_days, __props.comment?.available, __props.comment?.family_name, __props.comment?.given_name, __props.comment?.user_type)) + " " + _toDisplayString(__props.comment?.user_type == 'alumni' && [0, 1].includes(__props.comment?.is_deleted_in_30_days) ? `（ ${__props.comment?.display_name} ）` : ''), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.comment?.management_no + ' ' + __props.comment?.display_name), 1))
              ]))
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          (!__props.comment?.published)
            ? (_openBlock(), _createElementBlock("i", _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Submenu, {
              menu: _unref(menu),
              onShowDeleteCommentModal: showDeleteCommentModal,
              onShowUpdateCommentErrorModal: _ctx.showUpdateCommentErrorModal,
              published: __props.comment?.published
            }, null, 8, ["menu", "onShowUpdateCommentErrorModal", "published"])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(!__props.comment?.published ? 'opacity-30' : '')
      }, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(ChangeTime)(__props.comment?.created_at)), 1),
        _createVNode(TargetTag, {
          data: __props.comment?.comment,
          class: _normalizeClass('mb-0 fs-7 text-break break-spaces'),
          users: _unref(listUser)
        }, null, 8, ["data", "users"])
      ], 2)
    ], 2)
  ], 64))
}
}

})